import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  SmartTooltip,
  TableAdv,
  showToast,
  DualIcon,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { getCareerBuilderApplicantsDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import {
  CreateListModal,
  MailMergeModal,
} from "../Modals/MonsterModals/MonsterModals";
import { careerbuilderOptions } from "../../../../assets/data/enumData";
import { fetchCBBulkResumesDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { setcareerBuilderAccessidStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import AddNoteModal from "../../ConfirmedStart/Confirmed/modals/AddNoteModal";
import { formatWords2 } from "../../../../utils/stringUtils";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { fetchAllNotes } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import AiCallModel from "../Modals/AiCallModel";
import {
  getAllIntegrationAccess,
  getAllIntegrations,
} from "../../../../redux/slices/setting/settingApi";

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster",
};

const IntegratedCareerBuilder = ({
  cBQuery,
  onCBQueryChange,
  showResumeButton,
  keywords,
  source,
}) => {
  const { careerBuilder } = useSelector((state) => state.internalDbES);
  const {
    total,
    tableResponse = [],
    existingCandidates: existingCandidatesCB = [],
  } = careerBuilder;
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [mailMergeModalOpen, setMailMergeModalOpen] = useState(false);
  const [createListModal, setCreateListModal] = useState(false);
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [noteModal, setNotesModal] = useState(false);
  const candidate = existingCandidatesCB?.find((c) =>
    c?.resumeIds?.some((r) => r?.id === selectedApplicantId),
  );

  const candidateId = candidate?.uiid || candidate?.applicantId;
  const { loginUserUiid } = useLoginUser();
  const dispatch = useDispatch();
  const [mailMergeCandidates, setMailMergeCandidates] = useState([]);
  const [migrateModal, setMigrateModal] = useState(false);
  const [selectMigratedProfiles, setSelectedMigratedProfiles] = useState([]);
  const [defaultExistingCandidates, setDefaultExistingCandidates] = useState(
    [],
  );
  const [selected, setSelected] = useState([]);
  const [careerBuilderSort, setCareerBuilderSort] = useState("");
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [tableRenderKey, setTableRenderKey] = useState(0);
  const [isAiCallModalOpen, setIsAiCallModalOpen] = useState(false);
  const [hasAiCallAccess, setHasAiCallAccess] = useState(false);

  const firstRender = useRef(true);
  // console.log(tableResponse)
  // console.log(existingCandidatesCB)

  //console.log(cBQuery?.payload?.query?.Keywords);
  //  const noResumeCandidates = tableResponse.filter(
  //     item => !existingCandidatesCB.find(ex => ex.uiid === item.uiid)
  //   );
  const noResumeCandidates = (tableResponse || []).filter(
    (item) =>
      !existingCandidatesCB.find((ex) =>
        (ex?.resumeIds || []).some((r) => r?.id === item.resumeId),
      ),
  );
  //   console.log(noResumeCandidates)
  // console.log(selectedApplicantId)
  const noResumeCandidate = (noResumeCandidates || []).find(
    (c) => c?.resumeId === selectedApplicantId,
  );
  //  console.log(noResumeCandidate)
  const noResCandidateId =
    noResumeCandidate?.uiid || noResumeCandidate?.resumeId;
  const { accessData } = useSelector((state) => state.internalDbES);

  // const handleSelectionChange = (selected) => {
  //   ////////for checkbox
  //   const migratedApplicantIds = (tableResponse || [])
  //     .filter(r =>
  //       (existingCandidatesCB || []).some(c =>
  //         c?.resumeIds?.some(x => x.id === r.resumeId)
  //       )
  //     )
  //     .map(r => r.applicantId);
  //   const allSelectedAreMigrated = selected.every(id =>
  //     tableResponse.some(r =>
  //       r.applicantId === id &&
  //       (existingCandidatesCB || []).some(c =>
  //         c?.resumeIds?.some(x => x.id === r.resumeId)
  //       )
  //     )
  //   );
  //   setSelectedMigratedProfiles((allSelectedAreMigrated && selected.length === migratedApplicantIds.length) ? ["1"] : []);
  //   ///////for checkbox
  //   setSelected(selected);
  //   // setDefaultExistingCandidates(selected);
  //   setDefaultExistingCandidates(selected);
  //   const updatedCandidates = (tableResponse || [])
  //     .filter(doc => selected.includes(doc?.applicantId))
  //     .filter(Boolean);
  //   setMailMergeCandidates(updatedCandidates);
  // };

  const toggleMigratedCheckbox = (selected, tableData, migratedCandidates) => {
    const migratedIdsInTable = (tableData || [])
      .filter((row) =>
        (migratedCandidates || []).some((c) =>
          c?.resumeIds?.some((r) => r.id === row.resumeId),
        ),
      )
      .map((row) => row.applicantId);

    const isAllMigratedSelected =
      selected.length > 0 &&
      selected.length === migratedIdsInTable.length &&
      selected.every((id) => migratedIdsInTable.includes(id));

    setSelectedMigratedProfiles(isAllMigratedSelected ? ["1"] : []);
  };
  const handleDelete = (applicantId) => {
    // Update selected state
    setSelected((prev) => prev.filter((s) => s !== applicantId));
    setMailMergeCandidates((prev) =>
      prev.filter((candidate) => candidate.applicantId !== applicantId),
    );

    // For Career Builder - need to find the resumeId to match
    const resumeId = (existingCandidatesCB || []).find(
      (c) => c.uiid === applicantId,
    )?.resumeIds?.[0]?.id;
    const tableApplicantId = (tableResponse || []).find(
      (row) => row.resumeId === resumeId,
    )?.applicantId;
    const uiidToRemove = (tableResponse || []).find(
      (row) => row.applicantId === tableApplicantId,
    )?.uiid;
    const fallbackUiidMatch = (existingCandidatesCB || []).find(
      (c) => c.uiid === applicantId,
    )?.uiid;
    //  get all applicantIds with same uiid
    const targetUiid = uiidToRemove ?? fallbackUiidMatch;
    const applicantIdsByUiid = (existingCandidatesCB || [])
      .filter((row) => row.uiid === targetUiid)
      .flatMap((row) => row?.resumeIds?.map((r) => r.id) || []);

    setDefaultExistingCandidates((prev) => {
      const idsToRemove = new Set(applicantIdsByUiid || []);
      const updated = prev.filter((id) => !idsToRemove.has(id));
      setTableRenderKey((prev) => prev + 1);
      return updated;
    });
  };
  const handleSelectionChange = (selected) => {
    setSelected(selected);
    setDefaultExistingCandidates(selected);
    const updatedCandidatesIds = (tableResponse || [])
      .filter((doc) => selected.includes(doc?.applicantId))
      .map((data) => data?.resumeId)
      .filter(Boolean);
    const targetSet = new Set(updatedCandidatesIds);
    const foundItems = (existingCandidatesCB || []).filter((item) =>
      item?.resumeIds?.some((resume) => targetSet.has(resume?.id)),
    );
    const mailMergeData = foundItems.map((item) => ({
      applicantId: item.uiid,
      name: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
      email: item.email?.primary?.email ?? item.email?.primary ?? "",
      jobTitle: item.jobTitle ?? "-",
      experience: item.exp?.year ? item.exp.year : "-",
      payrate: item.salaryInfo?.payRate?.currency ?? "N/A",
      noticePeriod: item?.noticePeriod?.days ?? item.noticePeriod ?? 0,
    }));
    setMailMergeCandidates(mailMergeData);
    toggleMigratedCheckbox(selected, tableResponse, existingCandidatesCB); /////for checkbox
  };

  const mailSet = new Set(mailMergeCandidates.map((m) => m.resumeId));
  const matchedMigratedCandidates = selected.every((id) =>
    tableResponse.some(
      (r) =>
        r.applicantId === id &&
        (existingCandidatesCB || []).some((c) =>
          c?.resumeIds?.some((x) => x.id === r.resumeId),
        ),
    ),
  );
  const showMailMergeForMigrated =
    selected.length > 0 && matchedMigratedCandidates;

  const filtered = (existingCandidatesCB || [])
    .filter((c) => c.resumeIds?.some((r) => mailSet.has(r.id)))
    .map(({ firstName, lastName, jobTitle, uiid, email, exp, salaryInfo }) => ({
      applicantId: uiid,
      firstName,
      lastName,
      jobTitle,
      uiid,
      email: email?.primary?.email ?? email?.primary ?? "",
      experience: `${exp?.year ?? "-"} years ${exp?.mon ?? "-"} months`,
      payrate: salaryInfo?.payRate?.currency ?? "",
    }));
  // const handleDelete = (uiid) => {
  //   const resumeId = (existingCandidatesCB || [])
  //     .find(c => c.uiid == uiid)
  //     ?.resumeIds?.[0]?.id;
  //   if (!resumeId) return;
  //   const applicantId = (tableResponse || [])
  //     .find(row => row.resumeId == resumeId)
  //     ?.applicantId;
  //   if (!applicantId) return;
  //   const uiidToRemove = (tableResponse || []).find(
  //       (row) => row.applicantId === applicantId,
  //     )?.uiid;

  //     // 2. get all applicantIds with same uiid
  //     const applicantIdsByUiid = (tableResponse || [])
  //       .filter((row) => row.uiid === uiidToRemove)
  //       .map((row) => row.applicantId);

  //     setDefaultExistingCandidates((prev) => {
  //       const updated = prev.filter(
  //         (id) => !applicantIdsByUiid.includes(id),
  //       );
  //       setTableRenderKey((prev) => prev + 1);
  //       return updated;
  //     });
  //   setMailMergeCandidates((prev) => {
  //       const updated = prev.filter(
  //         (cand) => !applicantIdsByUiid.includes(cand.applicantId),
  //       );
  //       return updated;
  //     });
  //   setSelectedMigratedProfiles([]); /////for checkbox
  // };

  const fetchSubmissions = async () => {
    const formattedNoResumeCandidates = {
      resumeIds: noResumeCandidates.map((c) => c.resumeId).slice(0, 10),
      jobTitles: noResumeCandidates.map((c) => c.jobTitle).slice(0, 10),
      addedBy: loginUserUiid,
      // skillsToSearch: [cBQuery?.payload?.query?.Keywords] || ""
    };

    try {
      const params = {
        coll: "IntegrationAccess",
        fil: {
          userId: {
            type: "FIND_INTIGRATION_ACCESS",
            value: loginUserUiid,
            category: 3,
            categoryType: 2,
            status: 1,
          },
        },
        useAggregate: true,
      };

      const accessId = accessData?.careerBuilder?.[0]?.uiid
        ? accessData?.careerBuilder?.[0]?.uiid
        : dispatch(setcareerBuilderAccessidStart(params));

      const action = {
        accessId: accessId,
        payload: formattedNoResumeCandidates,
        userId: loginUserUiid,
      };
      try {
        const result = await new Promise((resolve, reject) => {
          dispatch(
            fetchCBBulkResumesDataStart({
              ...action,
              resolve,
              reject,
            }),
          );
        });

        setMigrateModal(false);
        if (
          result?.newApplicant.length > 0 ||
          result?.existingApplicant.length > 0
        ) {
          const count =
            (result?.newApplicant.length ?? 0) +
            (result?.existingApplicant.length ?? 0);
          showToast(`${count} Profiles Migrated Successfully`, "success", 2000);
        } else if (
          result?.failedResumes.length > 0 &&
          result?.failedResumes[0]?.error ==
            "Credits Expired. Please contact manager."
        ) {
          showToast("Credits Expired. Please contact manager.", "error", 3000);
        } else {
          showToast("Profile migration unsuccessful.", "error", 2000);
        }
        handleCBPagination();
      } catch (error) {
        showToast("Profile migration unsuccessful.", "error", 2000);
        console.error(error);
      }
    } catch (err) {
      showToast("Profile migration unsuccessful.", "error", 2000);
      console.error("Error fetching ResumeMining:", err);
    }
  };

  const handleMigratedProfiles = (currentValueArray) => {
    const isSelected =
      Array.isArray(currentValueArray) && currentValueArray.includes("1");

    if (!isSelected) {
      setDefaultExistingCandidates([]);
      setMailMergeCandidates([]);
      return;
    }

    let matchingCandidates = existingCandidatesCB;
    let totalData = tableResponse;

    // Collect all resumeIds from matching candidates
    const existingResumeIdSet = new Set(
      (matchingCandidates || [])
        .flatMap((candidate) => candidate?.resumeIds || [])
        .map((r) => {
          const id = r?.id ?? r;
          return id ? String(id) : null;
        })
        .filter(Boolean),
    );

    if (existingResumeIdSet.size === 0) {
      setDefaultExistingCandidates([]);
      setMailMergeCandidates([]);
      return;
    }

    // Filter totalData for candidates matching the resumeIds
    const filteredCandidates = (totalData || []).filter((doc) => {
      const docResumeId = doc?.resumeId?.id ?? doc?.resumeId;
      return docResumeId && existingResumeIdSet.has(String(docResumeId));
    });

    // Set mailMergeCandidates in the structured format
    const mailMergeData = filteredCandidates.map((doc) => {
      const foundItem = (matchingCandidates || []).find((item) =>
        item?.resumeIds?.some(
          (resume) =>
            String(resume?.id ?? resume) ===
            String(doc?.resumeId?.id ?? doc?.resumeId),
        ),
      );
      return {
        applicantId: foundItem?.uiid ?? doc?.applicantId,
        name: `${foundItem?.firstName ?? ""} ${
          foundItem?.lastName ?? ""
        }`.trim(),
        email:
          foundItem?.email?.primary?.email ?? foundItem?.email?.primary ?? "",
        jobTitle: foundItem?.jobTitle ?? "-",
        experience: foundItem?.exp?.year ?? "-",
        payrate: foundItem?.salaryInfo?.payRate?.currency ?? "N/A",
        noticePeriod:
          foundItem?.noticePeriod?.days ?? foundItem?.noticePeriod ?? 0,
      };
    });

    setMailMergeCandidates(mailMergeData);

    // Set default selected candidate IDs
    const candidatesIds = filteredCandidates
      .map((doc) => doc?.applicantId)
      .filter(Boolean);
    setDefaultExistingCandidates(candidatesIds);
  };

  //   const handleMigratedProfiles = (currentValueArray) => {
  //     // check if our single option '1' is actually selected
  //     const isSelected =
  //       Array.isArray(currentValueArray) && currentValueArray.includes("1");

  //     if (!isSelected) {
  //       // deselected: clear defaults

  //       setDefaultExistingCandidates([]);
  //       setMailMergeCandidates([])
  //       return;
  //     }

  //     // selected: compute candidates defensively
  //     const existingResumeIdSet = new Set(
  //       (existingCandidatesCB || [])
  //         .flatMap((candidate) => candidate?.resumeIds || [])
  //         .filter(Boolean)
  //         .map((r) => String(r?.id))
  //     );

  //     if (existingResumeIdSet.size === 0) {
  //       // nothing to match — clear to avoid "select all" behavior
  //       setDefaultExistingCandidates([]);
  //       return;
  //     }

  //     const candidates = (tableResponse || [])
  //       .filter((doc) => {
  //         // guard: only match when doc.resumeId exists and is in the set
  //         return doc?.resumeId && existingResumeIdSet.has(String(doc.resumeId));
  //       })
  //       .map((doc) => doc.applicantId);
  //     const candidatesData = (tableResponse || [])
  //       .filter((doc) => {
  //         // guard: only match when doc.resumeId exists and is in the set
  //         return doc?.resumeId && existingResumeIdSet.has(String(doc.resumeId));
  //       })
  // console.log(candidatesData)
  //     setMailMergeCandidates(candidatesData)
  //     setDefaultExistingCandidates(candidates);
  //   };

  // Pagination Helpers
  const { page, limit, setPage, handleLimitChange } = usePagination(
    cBQuery?.payload?.lim,
    (newPage, newLimit) => {},
    cBQuery?.payload?.page,
  );
  // const noResumeCandidate = (tableResponse || []).find((c) =>
  //     c?.applicantId === selectedApplicantId
  //   );
  const filteredApplicantData = existingCandidatesCB?.find((c) =>
    c?.resumeIds?.some((r) => String(r?.id) === String(selectedApplicantId)),
  );

  const sendData = {
    addedBy: { uiid: loginUserUiid },
    candidateId: { uiid: filteredApplicantData?.uiid },
  };

  const handleLimitChangeWithReset = (newLimit) => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
    handleLimitChange(newLimit);
  };

  const handlePageChange = (newPage) => {
    setSelected([]);
    setDefaultExistingCandidates([]);
    setMailMergeCandidates([]);
    setSelectedMigratedProfiles([]);
    setPage(newPage);
  };

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);
    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const columns = [
    // {
    //   key: "actions",
    //   label: "",
    //   columnMenu: false,
    //   render: (row) => (
    //     <div className="flex items-center">
    //       {existingCandidatesCB?.find((c) =>
    //         (c?.resumeIds || []).some(
    //           (r) => r?.id === row?.resumeId
    //         )
    //       )?.notes?.length > 0 && (
    //           <div
    //             onMouseEnter={() => {
    //               const isMatched = existingCandidatesCB?.find((c) =>
    //                 (c?.resumeIds || []).some(
    //                   (r) => r?.id === row?.resumeId
    //                 )
    //               );
    //               if (!isMatched) return;
    //               const uiids = isMatched?.notes
    //                 .filter((n) => n && typeof n === "object" && n?.uiid)
    //                 .map((n) => n.uiid);

    //               const others = isMatched?.notes.filter(
    //                 (n) => !(n && typeof n === "object" && n?.uiid)
    //               );
    //               const merged = [...uiids, ...others]
    //               getHoveredNotes(merged)
    //             }}
    //             onMouseLeave={() => setHoveredNotes([])}
    //           >

    //             <SmartTooltip noicon description={
    //               Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
    //                 <div className="flex flex-col gap-2">
    //                   {hoveredNotes?.map((hoveredNote, i) => (
    //                     <p key={i}>"{hoveredNote?.note || ""}" by {formatWords2(hoveredNote?.addedBy?.firstName) || ""} on {dateFormator(convertFromUTC(hoveredNote?.addedOn), "datetime-ampm") || ""}</p>
    //                   ))}
    //                 </div>
    //               ) : (
    //                 "Add note"
    //               )}>
    //               {existingCandidatesCB?.find((c) =>
    //                 (c?.resumeIds || []).some(
    //                   (r) => r?.id === row?.resumeId
    //                 )
    //               )?.notes?.length > 0 &&
    //                 <DualIcon
    //                   size="sm"
    //                   badgeIconColor={
    //                     existingCandidatesCB?.find((c) =>
    //                       (c?.resumeIds || []).some(
    //                         (r) => r?.id === row?.resumeId
    //                       )
    //                     )?.notes?.length > 0
    //                       ? "bg-success"
    //                       : "bg-dark"
    //                   }
    //                   onClick={() => {
    //                     const isMatched = existingCandidatesCB?.find((c) =>
    //                       c?.resumeIds?.some((r) => r?.id === row?.resumeId)
    //                     )
    //                     if (isMatched) {
    //                       setSelectedApplicantId(row?.resumeId);
    //                       setNotesModal(true);
    //                     }
    //                   }}
    //                 />
    //               }
    //             </SmartTooltip>
    //           </div>
    //         )}

    //       {existingCandidatesCB?.find((c) =>
    //         c?.resumeIds?.some((r) => r?.id === row?.resumeId)
    //       ) && (
    //           <SmartTooltip description={(() => {
    //             const migratedCandidate = existingCandidatesCB?.find((c) =>
    //               (c?.resumeIds || []).some((r) => r?.id === row?.resumeId)
    //             );

    //             return migratedCandidate
    //               ? `Migrated by ${formatWords2(migratedCandidate?.addedBy?.firstName ?? "-")} on ${dateFormator(migratedCandidate?.addedOn ?? "-")}`
    //               : "Migrated";
    //           })()} noicon>
    //             <Button
    //               type="icon"
    //               size="sm"
    //               variant="text"
    //               icon="save"
    //               color="black"
    //             />
    //           </SmartTooltip>
    //         )}
    //       <Button
    //         color="black"
    //         type="icon"
    //         variant="text"
    //         icon={"visibility"}
    //         onClick={() => {
    //           setSelectedApplicantId(row?.resumeId ?? "");
    //           setDetailsDrawer(true);
    //         }}
    //         size="sm"
    //       />
    //       {(row.id === 1 || row.id === 5) && (
    //         <Button
    //           color="black"
    //           type="icon"
    //           variant="text"
    //           size="sm"
    //           icon={"apk_install"}
    //         />
    //       )}
    //     </div>
    //   ),
    // },
    {
      key: "actions",
      label: "",
      columnMenu: false,
      render: (row) => {
        const matchedCandidate = (existingCandidatesCB ?? []).find((c) =>
          (c?.resumeIds ?? []).some(
            (r) => String(r?.id) === String(row?.resumeId),
          ),
        );
        const notes = Array.isArray(matchedCandidate?.notes)
          ? matchedCandidate.notes
          : [];
        const hasNotes = notes.length > 0;
        return (
          <div className="flex items-center">
            {hasNotes && (
              <div
                onMouseEnter={() => {
                  const uiids = notes
                    .filter((n) => n && typeof n === "object" && n?.uiid)
                    .map((n) => n.uiid);

                  const others = notes.filter(
                    (n) => !(n && typeof n === "object" && n?.uiid),
                  );

                  getHoveredNotes([...uiids, ...others]);
                }}
                onMouseLeave={() => setHoveredNotes([])}
              >
                <SmartTooltip
                  noicon
                  description={
                    hoveredNotes?.length > 0 ? (
                      <div className="flex flex-col gap-2">
                        {hoveredNotes.map((note, i) => (
                          <p key={i}>
                            "{note?.note || ""}" by{" "}
                            {formatWords2(note?.addedBy?.firstName) || ""} on{" "}
                            {dateFormator(
                              convertFromUTC(note?.addedOn),
                              "datetime-ampm",
                            ) || ""}
                          </p>
                        ))}
                      </div>
                    ) : (
                      "Add note"
                    )
                  }
                >
                  <DualIcon
                    size="sm"
                    badgeIconColor={hasNotes ? "bg-success" : "bg-dark"}
                    onClick={() => {
                      if (matchedCandidate) {
                        setSelectedApplicantId(row?.resumeId);
                        setNotesModal(true);
                      }
                    }}
                  />
                </SmartTooltip>
              </div>
            )}
            {matchedCandidate && (
              <SmartTooltip
                noicon
                description={`Migrated by ${formatWords2(
                  matchedCandidate?.addedBy?.firstName ?? "-",
                )} on ${dateFormator(matchedCandidate?.addedOn ?? "-")}`}
              >
                <Button
                  type="icon"
                  size="sm"
                  variant="text"
                  icon="save"
                  color="black"
                />
              </SmartTooltip>
            )}
            <Button
              color="black"
              type="icon"
              variant="text"
              icon="visibility"
              size="sm"
              onClick={() => {
                setSelectedApplicantId(row?.resumeId ?? "");
                setDetailsDrawer(true);
              }}
            />
            {/* {(row?.id === 1 || row?.id === 5) && (
              <Button
                color="black"
                type="icon"
                variant="text"
                size="sm"
                icon="apk_install"
              />
            )} */}
          </div>
        );
      },
    },
    {
      key: "name",
      label: "Name",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "location",
      label: "Location",
      columnMenu: false,
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false,
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "experience",
      label: "Experience",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[150px]!",
    },
    {
      key: "highestEducation",
      label: "Highest Education",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[150px]!",
    },

    {
      key: "source",
      label: "Source",
      columnMenu: false,
      width: "min-w-[100px]! max-w-[150px]!",
    },
    {
      key: "lastUpdate",
      label: "Last Updated",
      width: "min-w-[100px]! max-w-[150px]!",
      render: (row) => (
        <span className="text-xs text-gray-600">{row.lastUpdate}</span>
      ),
      columnMenu: false,
    },
  ];

  const rows = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    cId: 21542,
    name: "Shaun Marsh",
    // email: "marsh222@gmail.com",
    // contact: "+1(986)5487562",
    jobTitle: "IT Program Manager",
    experience: "3 years",
    // workAuth: "USA",
    location: "NC, Durham",
    source: "Naukri",
    // currentCtc: "$ 3,00,000",
    // noticePeriod: "1 Month",
    // createdBy: "Thomas Clark",
    // lastActive: "Fri,10 Jul 2025, 20:52 (6 days ago)",
  }));
  // console.log(cBQuery)
  // console.log(tableResponse)
  const integratedCBRows = Array.from(
    { length: tableResponse?.length || 0 },
    (_, i) => ({
      id: `cb-${tableResponse[i]?.applicantId || i}`,
      //cId: tableResponse[i]?.applicantId,
      name: formatWords2(tableResponse[i]?.name),
      location:
        tableResponse[i]?.location
          ?.split("-")
          ?.slice(1)
          ?.reverse()
          ?.join("-") ?? "N/A",

      jobTitle: formatWords2(tableResponse[i]?.jobTitle),

      experience: tableResponse[i]?.experience,
      highestEducation: tableResponse[i]?.highestEducation,
      source: getJobBoardsName[tableResponse[i]?.source],

      lastUpdate: tableResponse[i]?.lastUpdate,
      resumeId: tableResponse[i]?.resumeId,
    }),
  );

  const mappedRows = mapTableRows(integratedCBRows, columns);

  const handleCBPagination = () => {
    if (!cBQuery) {
      console.warn(
        "handleCBPagination: missing cBQuery, aborting pagination dispatch.",
      );
      return;
    }
    const updatedQuery = {
      ...cBQuery,
      payload: {
        ...cBQuery?.payload,
        query: {
          ...cBQuery?.payload?.query,
          ...(careerBuilderSort && { OrderBy: careerBuilderSort }),
        },
        page: page,
        lim: limit,
      },
    };

    dispatch(
      getCareerBuilderApplicantsDataStart({
        ...updatedQuery,
        onSuccess: () => {
          onCBQueryChange(updatedQuery);
        },
      }),
    );
  };

  // Pagination Use effect
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    handleCBPagination();
  }, [page, limit, careerBuilderSort]);

  // const handleApplicant = async () => {
  //   if()
  // }

  // useEffect(() => {
  //   handleApplicant();
  // }, [detailsDrawer])

  const fetchIntegrations = async () => {
    const integrationsPayload = {
      coll: "Integration",
      fil: JSON.stringify({
        category: { type: "NONE", value: 6 },
        type: { type: "NONE", value: 2 },
        status: { type: "NONE", value: 1 },
      }),
      ret: "uiid name",
    };
    const getIntegrations = await getAllIntegrations(integrationsPayload);

    if (getIntegrations?.success) {
      const integrationIds = getIntegrations?.data?.data?.map(
        (val) => val.uiid,
      );
      const integrationAccessPayload = {
        coll: "IntegrationAccess",
        fil: {
          integrationId: { type: "IN", value: integrationIds },
          userId: { type: "IN", value: loginUserUiid },
          status: { type: "IN", value: 1 },
        },
      };
      const getIntAccess = await getAllIntegrationAccess(
        integrationAccessPayload,
      );
      if (getIntAccess?.success) {
        setHasAiCallAccess(true);
      }
    }
  };

  useEffect(() => {
    fetchIntegrations();
  }, []);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="p-2">
        <FormFieldSet
          type="checkbox"
          noTitle
          multiple={true}
          options={[{ label: "Select Only Migrated Profiles", value: "1" }]}
          onChange={(raw) => {
            setTableRenderKey((prev) => prev + 1);
            const isChecked =
              raw &&
              typeof raw === "object" &&
              ("target" in raw || raw.nativeEvent)
                ? !!raw.target.checked
                : Array.isArray(raw)
                  ? raw.length > 0
                  : typeof raw === "boolean"
                    ? raw
                    : !!raw;
            const final = isChecked ? ["1"] : [];
            setSelectedMigratedProfiles(final);
            handleMigratedProfiles(final);
          }}
          values={selectMigratedProfiles}
        />
      </div>
      <TableAdv
        key={`${tableRenderKey}-${page}-${limit}`}
        columns={columns}
        rows={mappedRows}
        defaultSelectedRows={defaultExistingCandidates}
        showCheckbox
        onSelectionChange={handleSelectionChange}
        toolbarLeft={{
          add: [
            {
              component: (
                <div className="min-w-[200px]">
                  <FormFieldSet
                    type="select"
                    size="sm"
                    noTitle
                    placeholder={"Sort by"}
                    options={careerbuilderOptions}
                    onChange={(value) => setCareerBuilderSort(value)}
                  />
                </div>
              ),
            },
          ],
        }}
        toolbarRight={{
          // search: true,
          fullScreen: true,
          filter: false,
          add: [
            {
              component:
                (showMailMergeForMigrated &&
                  selectMigratedProfiles.includes("1")) ||
                (defaultExistingCandidates.length > 0 &&
                  matchedMigratedCandidates) ? (
                  <div className="flex items-center gap-2">
                    <Button
                      title="Mail Merge"
                      size="sm"
                      variant="outlined"
                      onClick={() => setMailMergeModalOpen(true)}
                    />
                    {hasAiCallAccess && (
                      <Button
                        title="Ai Call"
                        size="sm"
                        variant="outlined"
                        onClick={() => setIsAiCallModalOpen(true)}
                      />
                    )}
                    <Button
                      title="Create List"
                      size="sm"
                      onClick={() => setCreateListModal(true)}
                    />
                  </div>
                ) : (
                  <div className="flex gap-3">
                    <Button
                      title="Migrate profile"
                      size="sm"
                      onClick={() => setMigrateModal(true)}
                    />
                  </div>
                ),
            },
          ],
        }}
        serverPagination={true}
        totalCount={total}
        page={page}
        limit={limit}
        //onPageChange={handlePageChange}
        onLimitChange={handleLimitChangeWithReset}
        onPaginationChange={handlePageChange}
      />
      <Modal isOpen={migrateModal} showCloseButton={false}>
        <div className="py-3">
          <p className="text-center text-sm">
            The System will migrate the{" "}
            {noResumeCandidates.length > 10 ? 10 : noResumeCandidates.length}{" "}
            new profiles automatically. Please Click Yes to proceed
          </p>
          <div className="flex justify-center items-center gap-3 my-3">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setMigrateModal(false)}
            />
            <Button
              disabled={noResumeCandidates.length == 0 ? true : false}
              title={"Yes"}
              onClick={fetchSubmissions}
            />
          </div>
        </div>
      </Modal>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        showResumeButton={showResumeButton}
        onClose={() => setDetailsDrawer(false)}
        applicantId={candidateId || noResCandidateId}
        filteredApplicantData={noResumeCandidate}
        keywords={keywords}
        source={source}
      />
      <MailMergeModal
        mailMergeModalOpen={mailMergeModalOpen}
        filteredMonsterMailMergeData={mailMergeCandidates}
        handleDelete={handleDelete}
        setMailMergeModalOpen={setMailMergeModalOpen}
        selectedData={selected}
      />
      <CreateListModal
        SetShowCreateListModal={setCreateListModal}
        showCreateListModal={createListModal}
      />
      <AddNoteModal
       key={sendData?.candidateId?.uiid || sendData?.uiid}
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={sendData}
        source={2}
      />
      <AiCallModel
        isOpen={isAiCallModalOpen}
        onClose={() => setIsAiCallModalOpen(false)}
        // searchQuery={""}
        source={2}
        // selectedApplicants={filtered}
        selectedApplicants={[
          ...new Map(
            mailMergeCandidates.map((applicant) => [
              applicant.applicantId,
              applicant,
            ]),
          ).values(),
        ]}
      />
    </div>
  );
};

export default IntegratedCareerBuilder;
